import { detail } from './detail';

export const homes = {
    routeTitle: 'Standorte',
    route: 'Standorte',
    listOfHomes: 'Liste der Standorte',
    addHome: 'Standort hinzufügen',
    editHome: 'Standort bearbeiten',
    addHomeResident: 'Neuen Benutzer einladen',
    processingInvitationLink: 'Der Link zur Einladung wird bearbeitet, bitte warten...',
    invitationSuccesfullySent: 'Die Einladung wurde erfolgreich verschickt.',
    wrongUserInvitation1:
        'Fehler beim Versuch, die Einladung anzunehmen. Möglicherweise wurde die Einladung bereits angenommen, oder Sie sind mit dem falschen Benutzer verbunden. Sie sind derzeit als ',
    wrongUserInvitation2:
        ' verbunden. Bitte überprüfen Sie die Einladungs-E-Mail, melden Sie sich dann ggf. mit dem richtigen Benutzer neu an und versuchen Sie es erneut.',
    acceptInvitationSuccess: 'Einladung angenommen',
    name: 'Name',
    postalCode: 'Postleitzahl',
    owner: 'Besitzer',
    sureToDeleteContent: 'Name des gelöschten Standorts: ',
    sureToUndeleteContent: 'Name des wiederhergestellten Standorts: ',
    euroPerKwhBuy: 'Preis pro kWh Einkauf',
    euroPerKwhSell: 'Preis pro kWh Verkauf',
    kgco2PerKwh: 'kgCO2 pro kWh',
    capacity: 'Kapazität (kWp / kWh)',
    installationDate: 'Datum der Installation',
    kwLimit: 'Maximaler Netzbezug in kW verwendet für OCPP_Gateway Ladestation',
    kwhEuro: 'Eur/kWh',
    switchesInstalled: 'Schalter installiert',
    unlimited: 'Unbeschränkt',
    switchInstallationNotAllowed:
        'Die Installation eines weiteren Schalter ist nicht möglich. Bitte erhöhen sie ihre SW Lizenz',
    switchList: 'Schalter Liste',
    addSwitch: 'Neuen Schalter hinzufügen',
    priority: 'Prio',
    readyAt: 'Fertig um',
    offFrom: 'Aus von',
    offTo: 'Aus bis',
    assignedDevice: 'Gerät',
    assignedPhase: 'Phase',
    usageThresholdAlert: 'Stromverbrauch',
    alwaysOnAlert: 'Always on',
    dataMissingAlert: 'Fehlende Daten',
    next: 'Nächster >',
    back: '< Zurück',
    finish: 'Beenden',
    switchModel: 'Modell',
    switchName: 'Name',
    switchIotAddress: 'IoT hub/SmartPi Adresse',
    switchSSID: 'SSID des lokalen WLAN',
    switchWifiPassword: 'Passwort des lokalen WLAN',
    switchInstallationStep2:
        "Schalte die mobilen Daten aus; stecke den Schalter and die Stromversorgung; Verbinde dein Handy mit dem WLAN mit dem namen 'shelly....' und drücke 'Weiter'",
    switchInstallationStep3:
        "Verbinde dein Handy mit dem Internet und drücke 'Weiter'",
    switchInstallationStep4:
        'Dein Schalter ist erfolgreich konfiguriert. Bitte verbinde ihn mit einem Gerät. Diese Konfiguration folgt im nächsen Schritt.',
    editRelay: 'Relayis bearbeiten',
    editSwitch: 'Schalter bearbeiten',
    relayMode: 'Modus',
    relayDevice: 'Gerät',
    relayPhase: 'Phase',
    relayPriority: 'Priorität',
    relayReadyAt: 'Bereit um',
    relayOffFrom: 'Ausschalten von',
    relayOffTo: 'Ausschalten bis',
    deleteSwitch: 'Schalter löschen',
    confirmDeleteSwitch: 'Bist du sicher, dass du den Schalter löschen möchtest?',
    reconfig: 'Konfiguration ändern',
    modbusId: 'Modbus Id',
    ski: 'SKI',
    detail
};